/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { imagePrettyUrl } from 'gatsby-core-theme/src/helpers/getters';
import LazyImg from 'gatsby-core-theme/src/hooks/lazy-image';
import OperatorCta from 'gatsby-core-theme/src/components/atoms/button/operator-cta';
import StarRating from 'gatsby-core-theme/src/components/molecules/star-rating/one-star';
import CouponCode from 'gatsby-matrix-theme/src/components/atoms/coupon';
import Tooltip from 'gatsby-matrix-theme/src/components/atoms/tooltip';
import ReviewLink from 'gatsby-core-theme/src/components/atoms/review-link';
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight';
import Link from 'gatsby-core-theme/src/hooks/link';
import Bonus from 'gatsby-core-theme/src/components/molecules/bonus-box/template-one';
import GatsbyImg from 'gatsby-core-theme/src/hooks/gatsby-img';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { TrackingKeys } from '~constants/tracking-api'
import styles from './table.module.scss';

function removeDomain(url) {
  if (url) {
    const domainRegex = /^https?:\/\/[^/]+/;
    return url.replace(domainRegex, "");
  }
  return null; // Return null if the URL is invalid
}

const listHeadings = [
  {
    id: 1,
    defaultValue: 'Casino Information',
    key: 'casino_name',
  },
  {
    id: 2,
    defaultValue: 'Rating',
    key: 'rating',
  },
  {
    id: 3,
    defaultValue: 'Bonus',
    key: 'bonus',
    // customComponent: ({operator}) => ( <td>{operator.title}</td> ), This is an example
  },
  {
    defaultValue: 'Coupon code',
    key: 'coupon_code',
    customComponent: ({ operator }) => (
      <td>
        {operator?.relation?.extra_fields?.coupon_code && (
          <CouponCode code={operator.relation.extra_fields.coupon_code} showprefix={false} />
        )}
      </td>
    ),
  },
  {
    id: 4,
    defaultValue: 'Top Features',
    key: 'top_features',
  },
  {
    id: 5,
    defaultValue: 'Min. Deposit',
    key: 'min.deposit',
  },
  {
    id: 6,
    defaultValue: 'Payment Methods',
    key: 'payment_methods',
  },

  {
    id: 7,
    defaultValue: 'Currencies',
    key: 'currencies',
  },
  {
    id: 8,
    defaultValue: 'Licenses',
    key: 'licenses',
  },
  {
    id: 9,
    defaultValue: 'Website',
    key: 'website',
  },
];
export default function ComparisonTable({
  items,
  tabelInfo = listHeadings,
  ctaKey = 'play_now',
  type,
  tempate,
  operatorWidth = '64',
  operatorHeight = '64',
  paymentWidth = '45',
  paymentHeight = '30',
  licenseWidth = '72',
  licenseHeight = '32',
  moduleName= TrackingKeys?.COMPARISONTABLE,
  modulePosition,
}) {
  const cell = (heading, item, key, index) => {
    const rowData = tabelInfo.find((m) => m.key === heading);
    if (rowData && rowData.customComponent) {
      const CustomComponent = rowData.customComponent;
      return <CustomComponent key={key} operator={item} />;
    }
    const imageObject = item?.relation?.logo;
    const itemName = item?.relation?.name;

    switch (heading) {
      case 'casino_name':
        return (
          <td key={key} className={styles.casinoName}>
            {imageObject?.filename ? (
              <LazyImg
                src={imagePrettyUrl(imageObject?.filename, operatorWidth, operatorHeight)}
                height={operatorHeight}
                width={operatorWidth}
                alt={itemName}
              />
            ) : (
              <GatsbyImg
                filename="default-operator.png"
                alt={itemName}
                width="9rem"
                height="9rem"
              />
            )}
            <div>
              <span>{itemName}</span>

              {type === 'operator' && index === 0 ? null : (
                <ReviewLink
                  template={tempate}
                  {...(item?.relation?.name
                    ? { operatorName: item?.relation?.name }
                    : { pageName: item.title })}
                  reviewPath={item.path}
                  isComparisonTable={true}
                />
              )}
            </div>
          </td>
        );
      case 'rating':
        return (
          <td key={key} className={styles.raiting}>
            <StarRating numOfStars={5} rating={item?.relation?.rating} />
          </td>
        );
      case 'bonus':
        return (
          <td key={key} className={styles.bonus}>
            <Bonus
              tracker="main"
              item={item?.relation}
              moduleName={moduleName}
              modulePosition={modulePosition}
              itemPosition={index + 1}
            />
          </td>
        );
      case 'top_features':
        return (
          <td key={key} className={styles.topFeatures}>
            {item?.relation?.selling_points &&
              item?.relation?.selling_points.map((sellingPoint) => (
                <span key={sellingPoint}>{useTranslate(sellingPoint, sellingPoint)}</span>
              ))}
          </td>
        );
      case 'payment_methods':
        return (
          <td key={key} className={styles.paymentMethods}>
            <div key={key}>
              {item?.relation?.deposit_methods &&
                // eslint-disable-next-line array-callback-return
                item?.relation?.deposit_methods?.slice(0, 3)?.map((deposit) => {
                  const logo = deposit?.logo;
                  if (!logo) return;
                  return (
                    <Link to={deposit?.path}>
                      <LazyImg
                        key={`${key}-${deposit.name}`}
                        src={imagePrettyUrl(logo.filename, paymentWidth, paymentHeight)}
                        width={paymentWidth}
                        height={paymentHeight}
                        alt={deposit.name}
                      />
                    </Link>
                  );
                })}
            </div>
            {item?.relation?.deposit_methods?.length > 3 && (
              <Tooltip
                content={Object.values(item?.relation?.deposit_methods)
                  ?.slice(3)
                  ?.map((res) => res.name)
                  .toString()
                  .replace(/,/gi, ', ')}
                direction="bottom"
                minWidth={20}
              >
                {item?.relation?.deposit_methods.length - 3} {useTranslate('more', 'more')}
              </Tooltip>
            )}
          </td>
        );
      case 'min.deposit':
        return (
          <td key={key} className={styles.minDeposit}>
            {item?.relation?.min_deposit && <span>${item.relation.min_deposit}</span>}
          </td>
        );
      case 'currencies':
        return (
          <td key={key} className={styles.currencies}>
            {item?.relation?.currencies &&
              (() => {
                const currenciesArray = item?.relation?.currencies.slice(0, 6);
                const lastElementIndex = currenciesArray.length - 1;

                return currenciesArray.map((currency, index) => (
                  <React.Fragment key={`${key}-${currency.iso_code}`}>
                    <span>{currency.iso_code}</span>
                    {index !== lastElementIndex && <span>, </span>}
                  </React.Fragment>
                ));
              })()}
          </td>
        );
      case 'licenses':
        return (
          <td key={key} className={styles.licenses}>
            {item?.relation?.license_objects &&
              item?.relation?.license_objects.slice(0, 3).map((license) => {
                if (license?.standardised_logo?.url) {
                  return (
                    <LazyImg
                      key={license.name}
                      src={imagePrettyUrl(removeDomain(license.standardised_logo.url), licenseWidth, licenseHeight)}
                      height={licenseHeight}
                      width={licenseWidth}
                      alt={license.name}
                    />
                  );
                }
                return <></>;
              })}
          </td>
        );
      case 'website':
        return (
          <td className={styles.ctaButton}>
            {item?.relation?.status !== 'not_recommended' ? (
              <OperatorCta
                tracker="main"
                moduleName={moduleName}
                operator={item?.relation}
                icon={<FaArrowRight />}
                translationsObj={{
                  active: { translationKey: ctaKey, defaultValue: 'Visit' },
                  not_recommended: {
                    translationKey: 'not_recommended',
                    defaultValue: 'Not Recommended',
                  },
                  coming_soon: { translationKey: 'coming_soon', defaultValue: 'Soon Available' },
                  inactive: {
                    translationKey: 'inactive',
                    defaultValue: 'Not Accepting New Players',
                  },
                  blacklisted: { translationKey: 'blacklisted', defaultValue: 'Blacklisted' },
                }}
                // new key
                gtmClass="comparison-table-gtm btn-cta"
                pageTemplate={tempate}
                modulePosition={modulePosition}
                itemPosition={index + 1}
              />
            ) : (
              ''
            )}
          </td>
        );
      default:
        return null;
    }
  };

  const table = () => {
    const row = [];
    tabelInfo.forEach((heading) => {
      const cells = [];

      items.forEach((item, index) => {
        cells.push(cell(heading.key, item, `${heading.key}-${index}`, index));
      });

      row.push(
        <tr key={heading.key} className={`${styles[heading.key] || 'row'}_tr`}>
          <th>{useTranslate(heading.key, heading.defaultValue)}</th>
          {cells}
        </tr>
      );
    });

    return (
      <table className={styles.table}>
        <tbody>{row}</tbody>
      </table>
    );
  };

  return table();
}

ComparisonTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};
